function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 25.25C8.85082 25.25 8.70774 25.1907 8.60225 25.0852C8.49676 24.9798 8.4375 24.8367 8.4375 24.6875C8.4375 24.5383 8.49676 24.3952 8.60225 24.2898C8.70774 24.1843 8.85082 24.125 9 24.125C12.1016 24.125 14.625 21.6016 14.625 18.5C14.625 18.3508 14.6843 18.2077 14.7898 18.1023C14.8952 17.9968 15.0383 17.9375 15.1875 17.9375C15.3367 17.9375 15.4798 17.9968 15.5852 18.1023C15.6907 18.2077 15.75 18.3508 15.75 18.5C15.75 22.2226 12.7226 25.25 9 25.25ZM9 0.5C6.5565 0.5 0 12.6421 0 18.5C0 23.4624 4.03763 27.5 9 27.5C13.9624 27.5 18 23.4624 18 18.5C18 12.6421 11.4435 0.5 9 0.5Z"
});

function SvgIcAreaWaterDroplet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaWaterDroplet);
export default ForwardRef;